import React from 'react';

export const Button = React.forwardRef(({ children, onClick, disabled, className, ...props }, ref) => (
  <button ref={ref} onClick={onClick} disabled={disabled} className={className} {...props}>
    {children}
  </button>
));

Button.displayName = 'Button';

export default Button;
